export default {
  feedbackTitle: 'Transit Buy',
  swap: 'Swap&Bridge',
  markets: 'Pasar',
  comingSoon: 'Segera Hadir',
  startNow: 'Mulai Sekarang',
  copied: 'Disalin',
  verifyHuman: 'Verify Human',

  header: {
    buyToken: 'Beli Crypto',
    searchTokens: 'Cari Token',
    recentSearches: 'Pencarian Terbaru',
    popularTokens: 'Token Populer',
    noSearchContent: 'Token tidak ditemukan.',
    markets: 'Pasar',
    inscribeTool: 'Alat Inscribe',
  },

  appSetting: {
    theme: 'Tema',
    light: 'Terang',
    dark: 'Gelap',
    auto: 'Otomatis',

    language: 'Bahasa',
    langText: 'Inggris',

    showChart: 'Tampilkan Chart',
    contactUs: 'Hubungi Kami',
  },

  home: {
    modal_contact_us: {
      title: 'Hubungi Kami',
      text_1: "* Harap dicatat bahwa Transit tidak akan pernah menghubungi Anda terlebih dahulu, kami juga tidak akan meminta Anda untuk membayar biaya apapun.",
      text_2: 'Hubungi Transit Buy',
      serviceEmail: 'Email Layanan',
      telegram: 'Telegram',
      X: 'X (Twitter)',
      tips: 'Tersedia hanya untuk pertanyaan tentang OnRamp',
      desc1: "Staf Transit Finance tidak akan mengirim pesan pribadi kepada Anda!",
      desc2: "Peringatan! Anda memasuki komunitas Transit, mungkin ada seseorang yang menyamar sebagai kami untuk mengirim pesan pribadi! Harap waspada, siapa pun yang mengirim pesan pribadi bisa jadi penipu! Kami tidak akan pernah menghubungi Anda terlebih dahulu!",
      desc3: 'Mengerti, masuk',
      tg_text_1: 'Staf Transit Finance tidak akan pernah menghubungi saya terlebih dahulu!',
      tg_text_2: 'Siapa pun yang mengirim pesan pribadi kepada saya bisa jadi penipu!',
      tg_text_3: 'Saya tidak akan pernah membagikan informasi pribadi saya (termasuk frasa seed atau kunci pribadi) kepada siapa pun!',
    },
    text_1_1: 'Beli ',
    text_1_2: 'cryptocurrency',
    text_1_3: 'lebih mudah dengan',
    text_1_4: 'Transit Buy',
    text_2: 'Cryptocurrency',
    text_3: 'Negara',
    text_4: 'Mitra Kami',
    text_5: 'Beli dan jual cryptocurrency Anda dengan mitra dan metode pembayaran yang terpercaya',
    text_6: 'Lebih banyak pilihan, pengalaman yang lebih baik.',
    text_7: 'Membuat crypto lebih mudah & lebih nyaman bagi Anda',
    text_8: 'Anda dapat membeli dan menjual lebih dari 100 cryptocurrency dengan lebih dari 150 mata uang fiat menggunakan metode pembayaran favorit Anda.',
    text_9: 'Harga Terbaik',
    text_10: 'Kami akan membantu Anda memeriksa harga dari mitra kami dan menampilkan dalam daftar. Anda dapat memilih harga terbaik untuk diri Anda sendiri, dan juga metode pembayaran yang didukung.',
    text_11: 'Perlindungan Privasi',
    text_12: 'Sepanjang proses beli atau jual, semua privasi pribadi, termasuk informasi identitas dan detail pembayaran, dilindungi dan tidak akan diungkapkan.',
    text_13: 'Kepemilikan Sungguhan',
    text_14: 'Setelah membeli cryptocurrency, itu akan langsung dikirim ke alamat dompet Anda sendiri, memungkinkan transfer cryptocurrency tanpa batasan dan bebas. Anda benar-benar memilikinya!',
    text_15: 'Mulailah perjalanan crypto Anda sekarang',
    text_16: 'Beli dan jual lebih dari 100 cryptocurrency dengan lebih dari 150 mata uang fiat',
    card_text_1: 'Pilih metode pembayaran favorit Anda',
    card_text_2: 'Didukung oleh mitra on-ramp terkemuka di dunia',
    card_text_3: 'Lebih dari 100 negara dan wilayah di seluruh dunia tercakup.',
    card_text_4: 'USD, EUR, HKD, SGD, GBP, dan lebih dari 150 mata uang fiat lainnya didukung.',
    card_text_5: 'USDT, BTC, ETH, TRX, dan lebih dari 100 cryptocurrency lainnya terdaftar.',
  },

  ramp: {
    buy: 'Beli',
    sell: 'Jual',
    selectCurrency: 'Pilih Mata Uang',
    toBuy: 'Untuk Membeli',
    payWith: 'Bayar Dengan',
    selectToken: 'Pilih token',
    placeholder: 'Cari token',
    placeholder1: 'Cari mata uang fiat',
    popular: 'Populer',
    all: 'Semua',
    creditCard: 'Metode Pembayaran',
    providerTitle: 'Pilih Penyedia',
    providerDesc: 'Pilih penyedia yang dapat melayani Anda dengan terbaik!',
    providerDesc_1: 'Anda sedang mengonversi {currencyAmt} {currencyCoin} ke {cryptCoin}, pilih penyedia yang melayani Anda dengan terbaik!',
    providers: 'Penyedia',
    noProviders: 'Penyedia layanan tidak ditemukan~',
    estimated: 'Perkiraan untuk diterima',
    receiveAddress: 'Alamat Penerima',
    confirm: 'Konfirmasi',
    next: 'Selanjutnya',
    validAddress: 'Alamat Valid',
    limitAmount: 'Batas Jumlah',
    quotesStopped: 'Oops, kutipan dihentikan!',
    restart: 'Mulai Ulang',
    addressRequired: 'Alamat dompet diperlukan',
    paymentRequired: 'Metode pembayaran diperlukan',
    emptyText: 'Tidak ada metode pembayaran yang sesuai',
    orderFailed: 'Pesanan gagal, coba lagi',
    googlePayText_1: 'Metode pembayaran yang Anda pilih adalah Google Pay. Ikuti langkah-langkah di bawah untuk melanjutkan.',
    googlePayText_2: 'Kami telah menyalin URL pengalihan untuk Anda.',
    googlePayText_3: 'Buka browser sistem, tempelkan URL dan kunjungi situs web.',
    feeOff: 'Diskon 50%',
    hot: 'Tren',
  },

  footer: {
    Features: {
      title: 'Fitur',
      swap: 'Swap&Bridge',
      bridge: 'Bridge',
      market: 'Pasar',
      buyCrypto: 'Beli Crypto',
      explorer: 'Eksplorasi',
    },
    NFT: {
      title: 'NFT',
      design: 'Desain',
      transitNFT: 'Transit NFT',
      marketplace: 'Pasar',
    },
    Governance: {
      title: 'Tata Kelola',
      dao: 'DAO',
      donation: 'Donasi',
      fee: 'Biaya',
    },
    Community: {
      title: 'Komunitas',
      developers: 'Pengembang',
      forum: 'Forum',
      twitter: 'Twitter',
      downloadTP: 'Unduh TP',
    },
    Help: {
      title: 'Dapatkan Bantuan',
      contactUs: 'Hubungi Kami',
      helpCenter: 'Pusat Bantuan',
    },
    Links: {
      title: 'Tautan',
      TP: 'TokenPocket',
      Trading_View: 'Trading View',
      Terms: 'Syarat & Ketentuan',
      Privacy_Policy: 'Kebijakan Privasi',
      bugBounty: 'Bug Bounty',
    },
  },
};